import * as yup from 'yup';
import parsePhoneNumber from 'libphonenumber-js/max';

yup.addMethod(yup.string, 'phoneNumber', function (errorMessage) {
  return this.test(`phone-number-valid-test`, errorMessage, function (value) {
    const { path, createError } = this;
    if (
      !!value &&
      !parsePhoneNumber(
        `${this.parent?.phone_country.dial_code}${value}`
      )?.isValid()
    ) {
      createError({ path, message: errorMessage });
    } else {
      return true;
    }
  });
});

export const fullNameRegex = /([a-zA-Z]+\s?\b){2,}/;
export default yup;
